// import { AuthSession, fetchAuthSession, JWT } from "aws-amplify/auth";

export const getKeyPrefix = () => localStorage.getItem('keyPrefix');

export function getCurrentUser() {
  return localStorage.getItem(`${getKeyPrefix()}.LastAuthUser`);
}

function getKeyAccessToken() {
  return `${getKeyPrefix()}.${getCurrentUser()}.accessToken`;
}

export const setKeyPrefix = (keyPrefix: any) => localStorage.setItem('keyPrefix', keyPrefix);


export const getStoredAuthToken = async (): Promise<string | undefined> => {
  try {
    // const session: AuthSession = await fetchAuthSession();
    // Assuming accessToken is of type JWT and has a property that gives the string
    // const accessToken = session?.tokens?.accessToken;
    const accessToken = (localStorage.getItem("authToken") || '') as string;

    return accessToken; // Adjust property access as necessary
  } catch (error) {
    console.error(error);
    return undefined;
  }
};


// Useless
export const storeAuthToken = (token: any) => localStorage.setItem(getKeyAccessToken(), token);

// Useless
export const removeStoredAuthToken = () => localStorage.removeItem(getKeyAccessToken());
